/** Blob-URL verzögert widerrufen: der Download startet in manchen Browsern (Safari, ältere Firefox) asynchron. */
export const WIDERRUF_VERZOEGERUNG_MS = 1000;

export function widerrufeSpaeter(url: string): void {
  setTimeout(() => URL.revokeObjectURL(url), WIDERRUF_VERZOEGERUNG_MS);
}

/** Dateiname aus Content-Disposition: erst `filename*=UTF-8''…`, dann `filename="…"`, sonst Ersatz. */
export function dateinameAusHeader(cd: string, ersatz: string): string {
  const stern = /filename\*=UTF-8''([^;]+)/i.exec(cd)?.[1];
  let name: string | undefined;
  if (stern) {
    try {
      name = decodeURIComponent(stern);
    } catch {
      name = undefined;
    }
  }
  name = name ?? /filename="?([^";]+)"?/i.exec(cd)?.[1] ?? ersatz;
  return name.replace(/:/g, '-');
}
